"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkWMYJ7ELBjs = require('./chunk-WMYJ7ELB.js');var _chunkU6NJVEOJjs = require('./chunk-U6NJVEOJ.js');var _chunkOL2KRAIPjs = require('./chunk-OL2KRAIP.js');var _react = require('react');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var d=_styled2.default.call(void 0, _chunkWMYJ7ELBjs.a)`
  border-radius: 50%;
  padding: ${o=>o.theme.measurements.spacing(7)};
  background: ${o=>`${o.$buttonColor}33`};
  border-color: transparent;
  transition: 0.5s;

  &:hover,
  &:active,
  &:focus {
    transform: scale(1.1);
    background: ${o=>`${o.$buttonColor}33`};
    border-color: transparent;
  }

  svg {
    color: ${o=>o.$buttonColor};
  }
`;function m({topicColor:o,variant:l="fill"}){let a=_chunkOL2KRAIPjs.b.call(void 0, ).VIOLET,s=_react.useMemo.call(void 0, ()=>o||a,[o,l]);return _jsxruntime.jsx.call(void 0, d,{size:"large",$buttonColor:s,children:_jsxruntime.jsx.call(void 0, _chunkU6NJVEOJjs.b,{height:12,width:12})})}var g=m;exports.a = g;
